import * as React from "react"
import {isEmptyObject} from 'jquery';
import { I18NString, tr, goToAnchor } from "../Utils"
import { isUndefined } from 'lodash';
import Form from './Form'
import {ISectionSchema} from '../Section'
import {ControlErrorListItem, createControl, IControlError, IControlSchema} from "../Controls"
import { ApiClient } from '../../services/ApiClient'
import { ControlValueDispatcher} from '../controls/extensions/Dispatcher';
import {Dictionary} from "../../types/Dictionary";


interface Props{
    section: ISectionSchema;
    dispatcher:ControlValueDispatcher;
    disableNumber: boolean;
    countToSend: number;
    readonly: boolean;
    values: any;
    api: ApiClient;
    status: number;
    errors: Dictionary<IControlError | undefined>;
    visited: Dictionary<boolean>,
    allVisited: boolean,
    firstErrorId: string
}

interface State {
    scrolledSectionId?: string;
}

class Content extends React.Component<Props, State>{
        
    private tr: (message: I18NString) => string = tr;
    
    public constructor() {
        super();
        this.state = {
            scrolledSectionId: null
        }
    }

    componentDidUpdate() {
    }

    shouldComponentUpdate(nextProps : Props){
        return true;
    }

    render(){
        const { section, dispatcher, api, values } = this.props;
    
        if(!isEmptyObject(section)){
            let controls :  Array<React.ReactElement<any>> = [];

            for(let ctrl of section.controls){
                ctrl.disableNumber = this.props.disableNumber;
                const element = createControl(ctrl, api, dispatcher, this.props.errors, values, this.props.visited, this.props.allVisited);
                const key = `Content.${section.id}.${ctrl.id}`;
                controls.push(React.cloneElement(element, {key}));

                if(isUndefined(ctrl["visible"])) {
                    controls.push((<div key={`${key}.line`} className="line"></div>))
                }
                else if(ctrl["visible"]) {
                    controls.push((<div key={`${key}.line`} className="line"></div>))
                }
            }

            return (
                <div className="reportbox-content"> 
                    <h4>{this.tr(section.title)}</h4>
                    <div className="line"></div>
                    <Form>
                        {controls}
                    </Form>
                </div>
            )
        }
        
        return <div></div>
    }
}

export default Content




// WEBPACK FOOTER //
// ./src/components/request/Content.tsx